import { useMutation, useQueryClient } from "@tanstack/react-query";
import { administratorMethods } from "../api/apiMethods";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { queryKeys } from "../queries/queryKeys";
import { Logger } from "../utils/logger/Logger";
import { AdministratorUpdateInput } from "../views/AdministratorView/administratorTypes";

export const useUpdateAdministratorMutation = (options: {
    onSuccess: () => void;
    onError: (error: any) => void;
}) => {
    const queryClient = useQueryClient();
    const municipalityId = useSelectedMunicipalityId();

    const mutation = useMutation({
        mutationFn: async (data: {
            administratorId?: string;
            input: AdministratorUpdateInput;
        }) => {
            if (!municipalityId) {
                throw new Error("No municipality Id");
            }

            if (!data.administratorId) {
                throw new Error("No administrator id");
            }

            return administratorMethods(municipalityId).updateAdministrator(
                data.input,
                data.administratorId
            );
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.administrator.byId(
                    municipalityId,
                    variables.administratorId
                ),
            });
            options.onSuccess();
        },
        onError: async (error: Response) => {
            Logger.error(error);

            let parsedError;
            try {
                parsedError = await error.json();
            } catch {}

            options.onError(parsedError);
        },
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: queryKeys.administrator.all(municipalityId),
            });
            queryClient.invalidateQueries({
                queryKey: queryKeys.orderer.all(municipalityId),
            });
        },
    });

    return mutation;
};
